<template>
  <div class="notification-card p-2">
    <div class="notification-card__heading font-weight-bold pb-2">
      進路活動記録
    </div>
    <div
      class="notification-card__content"
      @click="onClickActivePart">
      <div class="d-flex align-items-center">
        <img
          v-if="notification.pathActivityComment.createdBy.avatar"
          class="img-fluid rounded-circle member__img--notification mr-2"
          :src="notification.pathActivityComment.createdBy.avatar">
        <b-avatar
          v-else
          :text="notification.pathActivityComment.createdBy.name | initial"
          class="mr-2" />
        <div class="member__content d-flex align-items-center">
          <p class="member__name mr-2">
            {{ notification.pathActivityComment.createdBy.name }}
          </p>
          <p class="member__title">
            {{ notification.pathActivityComment.createdAt | prettyDateTime }}
          </p>
        </div>
      </div>
      <div>
        <div class="notification-card__detail">
          {{ notification.pathActivityComment.detail }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    notification: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
      checked: false,
      isProtecting: false
    }
  },
  methods: {
    async onClickActivePart() {
      this.$emit('click-notification', this.notification.id)
    },
    onCheckRead() {
      this.checked = !this.checked
      this.$emit('check-read', this.notification.id)
    },
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/stylesheets/member';

.notification-card {
  &__heading {
    font-size: $fs-nm;
    font-weight: bold;
  }
  &__content {
    padding: 8px;
    background-color: $grey15;
  }
  &__detail {
    padding: 8px;
  }
}

.member__img--notification {
  width: 30px;
  height: 30px;
  object-fit: cover;
}

</style>